import { render, staticRenderFns } from "./NotificationsPosition.vue?vue&type=template&id=908cf3c8"
import script from "./NotificationsPosition.vue?vue&type=script&lang=js"
export * from "./NotificationsPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports